export default "__VITE_ASSET__B67gc_yR__"